<template>
  <v-card flat tile class="templates-landing">
    <v-card-text>
      <v-row class="pb-2" align="end">
        <v-col class="d-flex" sm="4">
          <div class="d-flex flex-column flex-grow-1">
            <label>Property</label>
            <property-selector :value="property.value" @input="reloadTemplates"></property-selector>
          </div>
        </v-col>
        <v-col sm="3">
          <!--<v-layout row wrap justify-end>
            <div id="IncludeArchived">
              <v-switch v-model="includeArchived" label="Include Archived" class="pt-2"></v-switch>
            </div>
          </v-layout>-->
        </v-col>
        <v-col class="d-flex justify-end" sm="5">
          <span class="px-2"></span>
          <res-button :dark="true"
                      :depressed="true"
                      buttonText='+ New GL Account Template'
                      backgroundColor='var(--v-resGreen-base)'
                      borderColor='var(--v-resGreen-base)'
                      buttonTextColor='white'
                      @click="openNewEditTemplateDialog"
                      font-size="12px">
          </res-button>
          <new-edit-template-dialog v-if="showNewEditTemplateDialog"
                                    :showDialog="showNewEditTemplateDialog"
                                    :maxWidth="775"
                                    :setWidth="775"
                                    mode="new"
                                    :template="newTemplate"
                                    @save="save"
                                    @cancel="cancelNewEditTemplateDialog">
          </new-edit-template-dialog>
          <div class="help-controls step-down ml-2" @click="openHelp(null)">
            <span class="help-label">Help</span>
            <v-icon color="var(--v-resBlue-darken1)" class="pb-1">mdi-help-circle</v-icon>
          </div>
          <res-dialog :showDialog="showHelp"
                      titleClass="resBlue darken-1 white--text"
                      iconColor="white"
                      cancelButtonText="Close"
                      :cancelButtonOnly="true"
                      cancelButtonColor="resBlue darken-1"
                      :maxWidth="800"
                      :setWidth="800"
                      :setHeight="600"
                      attach=".templates-landing"
                      @cancel="closeHelp">
            <templates-help :openSection="openHelpSection"></templates-help>
          </res-dialog>
        </v-col>
      </v-row>

      <v-container class="pa-0 tabs-container">
        <v-card outlined>
          <v-row>
            <v-col class="d-flex" cols="12" sm="12">
              <v-tabs v-model="tab" class="resman-tabs" active-class="resman-active-tab">
                <v-tabs-slider color="resBlue darken-1"></v-tabs-slider>
                <v-tab v-for="item in tabs"
                       :key="item.id" :class="item.class">
                  {{ item.text }}
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>
        </v-card>
      </v-container>

      <res-data-table :headers="headers"
                      :items="tabbedItems"
                      :item-class="getTemplateItemClass"
                      single-select
                      item-key="templateId"
                      :sort-by="sortBy"
                      :sort-desc.sync="sortDescending"
                      :slotOptions="['action']"
                      @selected-items="updateSelectedItems($event)">
        <template v-slot:[`item.action`]="{ item }">
          <div class="d-flex">
            <router-link :to="{ name: 'BudgetGroups', params: { templateId: item.templateId }}" class="mr-5 link-btn mt-2">
              <v-icon color="resBlue">mdi-pencil</v-icon>
            </router-link>
            <v-menu offset close-on-click>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="var(--v-resBlue-darken1)">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-if="!item.isArchived">
                  <v-list-item-title>
                    <span class="resGrey--text text--darken-1 pointer" @click="openCopyTemplateDialog(item)">Copy</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <span class="resGrey--text text--darken-1 pointer" @click="openArchiveTemplateDialog(item)">{{ item.isArchived ? "Un-archive" : "Archive" }}</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </res-data-table>
    </v-card-text>

    <copy-template-dialog :showDialog="showCopyTemplateDialog"
                          :templateTitle="selectedTemplate.title"
                          @confirmCopy="copyTemplate"
                          @cancelCopy="cancelCopyTemplateDialog">
    </copy-template-dialog>

    <archive-template-dialog :showDialog="showArchiveTemplateDialog"
                          :templateTitle="selectedTemplate.title"
                          :restoreMode="selectedTemplate.isArchived"
                          @confirmArchive="archiveTemplate"
                          @cancelArchive="cancelArchiveTemplateDialog">
    </archive-template-dialog>
  </v-card>
</template>

<script>
  import ResButton from '@/components/base/ResButton';
  import ResDataTable from '@/components/base/ResDataTable.vue';
  import PropertySelector from '@/components/properties/PropertySelector.vue';
  import NewEditTemplateDialog from '../dialogs/NewEditTemplateDialog.vue';
  import CopyTemplateDialog from '../dialogs/CopyTemplateDialog.vue';
  import ArchiveTemplateDialog from '../dialogs/ArchiveTemplateDialog.vue';
  import ResDialog from '@/components/base/ResDialog.vue';

  import TemplatesHelp from '@/components/help/TemplatesHelp.vue';
  import HelpableMixin from '@/mixins/Helpable.js';

  import templateService from '@/services/template'

  import { mapActions } from 'vuex'
  
  export default {
    name: 'GLAccountsTemplatesLanding',
    mixins: [HelpableMixin],
    components: {
      ResButton,
      ResDataTable,
      ResDialog,
      PropertySelector,
      NewEditTemplateDialog,
      CopyTemplateDialog,
      TemplatesHelp,
      ArchiveTemplateDialog
    },
    data: function () {
      return {
        property: { text: '', value: '' },
        sortBy: "name",
        sortDescending: false,
        //includeArchived: false,
        showNewEditTemplateDialog: false,
        showPopulateSourceDialog: false,
        showCopyTemplateDialog: false,
        showArchiveTemplateDialog: false,
        showDeleteDialog: false,
        selectedTemplate: {},
        newTemplate: {
          name: '',
          selectedProperties: [],
          isArchived: false
        },
        headers: [],
        templates: [],
        tab: null
      };
    },
    computed: {
      tabs() {
        return [
          { id: 1, text: 'VIEW ALL (' + this.templates.length + ')', class: '' },
          { id: 2, text: 'ARCHIVED (' + this.archivedTemplates.length + ')', class: 'resman-right-tab' },
        ];
      },
      archivedTemplates () {
        let tempTemplates = this.templates;
        tempTemplates = tempTemplates.filter((item) => {
          return (item.isArchived);
        });
        return tempTemplates;
      },
      tabbedItems() {
        console.log(this.tab)
        switch (this.tab) {
          case 0:
            return this.templates;
          case 1:
            return this.archivedTemplates;
          default:
            return this.templates;
        }
      }
    },
    methods: {
      ...mapActions(['changeLoading', 'activateErrorDialog']),
      getTemplateItemClass(item) {
        return item.isArchived ? "archived-template" : "";
      },
      updateSelectedItems(selected) {
        this.selectedTemplates = selected;
      },
      /* New Template Logic */
      openNewEditTemplateDialog() {
        this.showNewEditTemplateDialog = true;
      },
      cancelNewEditTemplateDialog() {
        this.showNewEditTemplateDialog = false;
        this.newTemplate = { name: '', selectedProperties: [], isArchived: false };
      },
      async save() {
        var self = this;
        self.changeLoading(true);
        const propertyIds = self.newTemplate.selectedProperties.map(prop => { return prop.value; });
        let response = await templateService.createTemplate(self.newTemplate.name, self.newTemplate.sortType, propertyIds);
        if (response.success == true) {
          const templateId = response.data.templateId;
          this.newTemplate = { name: '', selectedProperties: [], isArchived: false };
          self.changeLoading(false);
          this.$router.push({ name: 'BudgetGroups', params: { templateId: templateId } });
        } else {
          self.changeLoading(false);
          //this is handled generically in services/api/index.js
          //this.activateErrorDialog({title: 'Create Template Failed', message: response.data});
        }
      },
      /* Copy Template Logic */
      openCopyTemplateDialog(template) {
        this.selectedTemplate = template;
        this.showCopyTemplateDialog = true;
      },
      cancelCopyTemplateDialog() {
        this.selectedTemplate = {};
        this.showCopyTemplateDialog = false;
      },
      async copyTemplate() {
        var t = this;
        t.changeLoading(true);
        let response = await templateService.copyTemplate(t.selectedTemplate.templateId);
        if (response.success) {
          t.selectedTemplate = {};
          t.showCopyTemplateDialog = false;
          t.changeLoading(false);
          t.$router.push({ name: 'BudgetGroups', params: { templateId: response.data } });
        } else {
          t.changeLoading(false);
          //this is handled generically in services/api/index.js
          //this.activateErrorDialog({title: 'Copy Template Failed', message: response.data});
        }
      },
      /* Archive Template Logic*/
      openArchiveTemplateDialog(template) {
        this.selectedTemplate = template;
        this.showArchiveTemplateDialog = true;
      },
      cancelArchiveTemplateDialog() {
        this.selectedTemplate = {};
        this.showArchiveTemplateDialog = false;
      },
      async archiveTemplate() {
          var t = this;
          t.changeLoading(true);
          let response = await templateService.archiveTemplate(t.selectedTemplate.templateId, t.selectedTemplate.isArchived == false);
          if (response) {
            t.selectedTemplate = {};
            t.showArchiveTemplateDialog = false;
            await t.loadTemplates();
            t.changeLoading(false);
          } else {
            t.changeLoading(false);
            //this is handled generically in services/api/index.js
            //this.activateErrorDialog({title: 'Archive Template Failed', message: response.data});
          }
      },
      async reloadTemplates(property) {
        this.loading = true;
        this.property = property;
        await this.loadTemplates();
        this.loading = false;
      },
      async loadTemplates() {
        let templateData = (this.property && this.property.value && this.property.value.length == 36) ?
            await templateService.getAllByPropertyId(this.property.value, true /*this.includeArchived*/) :
            await templateService.getAll(true /*this.includeArchived*/);
        if (templateData && templateData.headers && templateData.data) {
          this.headers = templateData.headers;
          this.templates = templateData.data;
        } else {
          this.headers = [];
          this.templates = [];
        }
      }
    },
    async mounted() {
      await this.loadTemplates();
      this.loading = false;
    },
    watch: {
      includeArchived: function () {
          this.loadTemplates();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .link-btn {
      text-decoration: none !important;
  }
  .resman-tab {
    color: var(--v-resGrey-darken1) !important;
    font-weight: normal !important;
    font-size: 18px !important;
  }

  .resman-tab.resman-active-tab {
    font-weight: 500 !important;
    color: var(--v-resBlue-darken1) !important;
  }

  .v-data-table-header th.resGrey-background {
    background-color: var(--v-resGrey-lighten3) !important;
  }

  #IncludeArchived { 
      ::v-deep.v-input__slot {
        align-items: flex-end;
        margin: 0;
      }
  }
  .help-controls {
    float: right;
    height:36px;
    border-radius: 5px;
    border: solid 1px var(--v-resGrey-lighten3);
    padding: 7px 6px 6px 6px;
    cursor: pointer;
  }
  .tabs-container {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .resman-right-tab {
    margin-left: auto;
  }
</style>

<!-- Non-scoped needed for dynamic table row classes -->
<style lang="scss">
  .v-data-table tr.archived-template {
    color: lightgray;
  }
</style>
